import { format as dateFnFormat } from 'date-fns'
import momentToDateFns from './momentToDateFns'
import isoStringToDate from './isoStringToDate'
import {
  applyDateTranslations,
  getDateFnsLocale,
  applyLanguageSpecificFormatting,
  getTranslationsForLanguage,
  getLocaleDateFormat,
} from './applyDateTranslations'
// helps us distinguish between prisma locale and dateFns locale
import { type Locale } from '@messenger/types'
import { LOCALE } from '@messenger/consts'

export const formatDate = (
  date: Date | string,
  format: string,
  isMomentJSFormat: boolean = false,
  locale: Locale = LOCALE.EN,
): string => {
  const convertedFormat = isMomentJSFormat ? momentToDateFns(format) : format
  const fallbackFormat = convertedFormat || 'MMMM do yyyy'
  const covertedFormatWithLocale = getLocaleDateFormat(locale, convertedFormat)
  const convertedDate = isoStringToDate(date)
  const isDate = convertedDate instanceof Date
  const dateFnsLocale = getDateFnsLocale(locale)
  const localeOptions = dateFnsLocale ? { locale: dateFnsLocale } : undefined

  let formattedDate = ''

  if (isDate) {
    // this should work in most cases, and requires very little maintenance
    try {
      formattedDate = dateFnFormat(
        convertedDate,
        covertedFormatWithLocale,
        localeOptions,
      )
    } catch (error) {
      console.error(
        `Error formatting date: ${convertedDate}, locale: ${locale}, localeOptions: ${localeOptions}, error: ${error}`,
      )
      // fallback to non-locale specific format
      formattedDate = dateFnFormat(convertedDate, fallbackFormat)
    }
    formattedDate = applyLanguageSpecificFormatting(formattedDate, locale)
  } else if (date === null) {
    formattedDate = ''
  } else {
    // fallbacks provide a safety net, and require more maintenance
    const translations = getTranslationsForLanguage(locale)
    if (translations) {
      formattedDate = applyDateTranslations(String(date), translations, locale)
    } else {
      formattedDate = String(date)
    }
  }

  return formattedDate
}

export default formatDate
